// src/components/status-sheet/ReportTable.jsx
// Generic titled table for the Status Sheet. columns = [{ key, label, align?,
// render?, className?, width? }]; rows = array of objects. Fixed layout — pass
// width (e.g. "34%") so the same columns line up across every table on the
// page like a grid. Prints clean (black on white).
export default function ReportTable({ title, subtitle, columns, rows, empty }) {
  return (
    <section className="mb-6 break-inside-avoid">
      {title && (
        <h3 className="text-sm font-bold uppercase tracking-wide text-slate-800 border-b-2 border-slate-800 pb-1 mb-2">
          {title}
          {subtitle && (
            <span className="ml-2 text-xs font-medium text-slate-500 normal-case">
              {subtitle}
            </span>
          )}
        </h3>
      )}
      {!rows || rows.length === 0 ? (
        <p className="text-xs text-slate-400 mb-3">{empty || "None."}</p>
      ) : (
        <table className="w-full table-fixed text-[12px] border-collapse mb-3">
          <thead>
            <tr className="text-left text-slate-500 border-b border-slate-300">
              {columns.map((c) => (
                <th
                  key={c.key}
                  style={c.width ? { width: c.width } : undefined}
                  className={`py-1 pr-3 font-semibold ${
                    c.align === "right" ? "text-right pr-0 pl-3" : ""
                  }`}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={row.id || row.dealId || i}
                className="border-b border-slate-100 align-top"
              >
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={`py-1 pr-3 text-slate-800 break-words ${
                      c.align === "right" ? "text-right pr-0 pl-3" : ""
                    } ${c.className || ""}`}
                  >
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
